import {
  MUTUAL_FUND,
  CLOSED_END_FUND,
  ETF_FUND,
  ETF_INDEX_FUND,
  RETAIL_PRODUCTS,
  CLOSED_END_PRODUCTS,
  ETF_PRODUCTS,
  MUTUAL_FUND_PATH,
  ETF_PATH,
  FUTURE_SCHOLAR_529_PRODUCTS,
  FUTURE_SCHOLAR_529_PATH,
  FUTURE_SCHOLAR_529,
  VARIABLE_FUND,
  VARIABLE_PATH,
  VARIABLE_PRODUCTS,
  CLOSED_END_PATH,
  MODEL_PORTFOLIOS,
  MODEL_PORTFOLIOS_PATH,
  MODEL_PORTFOLIOS_PRODUCTS,
  INTERVAL_FUND,
  INTERVAL_FUND_PATH,
  INTERVAL_FUND_PRODUCTS,
  SEPARATELY_MANAGED_ACCOUNTS,
  SEPARATELY_MANAGED_ACCOUNTS_PATH,
  SEPARATELY_MANAGED_ACCOUNTS_PRODUCTS,
} from '../Helpers/FundTypes.js'

function setFundGroupProductTypeAndFundPath(fund) {
  const fundGroup = fund.miscellaneousDetails.fundGroup

  switch (fundGroup) {
    case 'Retail':
    case 'Retail and Institutional':
      fund.fundGroup = MUTUAL_FUND
      fund.productType = RETAIL_PRODUCTS
      fund.fundPath = MUTUAL_FUND_PATH
      break
    case 'Closed End':
      fund.fundGroup = CLOSED_END_FUND
      fund.productType = CLOSED_END_PRODUCTS
      fund.fundPath = CLOSED_END_PATH
      break
    case 'Retail ETF':
      fund.fundGroup = ETF_FUND
      fund.productType = ETF_PRODUCTS
      fund.fundPath = ETF_PATH
      break
    case 'Future Scholar 529':
      fund.fundGroup = FUTURE_SCHOLAR_529
      fund.productType = FUTURE_SCHOLAR_529_PRODUCTS
      fund.fundPath = FUTURE_SCHOLAR_529_PATH
      break
    case 'Variable Products':
      fund.fundGroup = VARIABLE_FUND
      fund.productType = VARIABLE_PRODUCTS
      fund.fundPath = VARIABLE_PATH
      break
    case 'Model Portfolios':
      fund.fundGroup = MODEL_PORTFOLIOS
      fund.productType = MODEL_PORTFOLIOS_PRODUCTS
      fund.fundPath = MODEL_PORTFOLIOS_PATH
      break
    case 'Interval Fund':
      fund.fundGroup = INTERVAL_FUND
      fund.productType = INTERVAL_FUND_PRODUCTS
      fund.fundPath = INTERVAL_FUND_PATH
      break
    // Need this because fund.miscellaneousDetails.fundGroup is separately managed accounts
    // Then productType is set and allowes for productList to get by category
    case 'Separately Managed Accounts':
      fund.fundGroup = SEPARATELY_MANAGED_ACCOUNTS
      fund.productType = SEPARATELY_MANAGED_ACCOUNTS_PRODUCTS
      fund.fundPath = SEPARATELY_MANAGED_ACCOUNTS_PATH
      break
    default:
      fund.fundGroup = MUTUAL_FUND
  }

  if (fund.miscellaneousDetails.layoutID === '36') {
    fund.fundGroup = ETF_INDEX_FUND
    fund.productType = ETF_PRODUCTS
    fund.fundPath = ETF_PATH
  }
}

export { setFundGroupProductTypeAndFundPath }
